import React from 'react';
import { Element, Color, FontType } from '@americanexpress/aqx-components';
import FeatureBullet from './FeatureBullet';

const BenefitItem = ({ header, content, description, styles = {} }) => (
  <Element theme={{ paddingLeft: 10 }} className={styles.benefitItem}>
    <Element
      Component="h2"
      theme={{
        textHeading: 4,
        color: Color.DeepBlue,
        padding: 'none',
        paddingRight: 20,
        margin: 'none',
        fontType: FontType.BentonBold
      }}
      className={styles.benefitHeader}
    >
      {header}
    </Element>
    <React.Fragment>
      {description && <FeatureBullet description={description} styles={styles} />}
      {(content || []).map((contentItem, i) => (
        <FeatureBullet {...contentItem} key={`contentItem${i}`} styles={styles} />
      ))}
    </React.Fragment>
  </Element>
);

export default BenefitItem;
